import { Trans, useLingui } from "@lingui/react/macro";
import { ActivitiesTable } from "./ActivitiesTable";
import { PlainButton } from "@medoma/components/Button/Button";
import PlusIcon from "@medoma/components/icons/PlusIcon";
import ExpandFullIcon from "@medoma/components/icons/ExpandFullIcon";
import { PageToolbar } from "@/components/PageToolbar/PageToolbar";
import { useNavigate } from "react-router";
import styles from "./index.module.scss";
import { useActivitiesViewToolbar } from "./useActivitiesViewToolbar";
import { SingleToggleButton } from "@medoma/components/ToggleButton/SingleToggleButton";

export const Activities = () => {
  const navigate = useNavigate();
  const { t } = useLingui();
  const { expandedRowLayout, setExpandedRowLayout } =
    useActivitiesViewToolbar();

  return (
    <>
      <PageToolbar showDaySwitcher>
        <div className={styles.tools}>
          <div className={styles.actions}>
            <PlainButton onClick={() => navigate(`new`)}>
              <PlusIcon />
              <Trans>Skapa aktivitet</Trans>
            </PlainButton>
          </div>
          <div className={styles.viewOptions}>
            <SingleToggleButton
              aria-label={t`Expanderat läge`}
              isSelected={expandedRowLayout}
              onChange={setExpandedRowLayout}
            >
              <ExpandFullIcon />
            </SingleToggleButton>
          </div>
        </div>
      </PageToolbar>
      <ActivitiesTable />
    </>
  );
};
